import { gql } from "@apollo/client";


export const VALIDATE_EXIST_MATRICULA_BY_ORIGEN = gql`
query ExisteMatriculaByOrigen(
  $idOrigenMatricula: Int!, 
  $numero: String!) {
  existeMatriculaByOrigen(
    idOrigenMatricula: $idOrigenMatricula, 
    numero: $numero
  ) 
}
`;